import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type ReportAccessGrant } from '@webapp/platform/iam/entities/ReportAccessGrant'
import { type User } from '@webapp/platform/iam/entities/User'
import messages from './messages'
import { useMutateGrantReportAccess } from '../../models/useMutateGrantReportAccess'

export const useGrantReportAccessPresenter = () => {
  const intl = useProcurifyIntl()
  const { grantReportAccess, isGranting } = useMutateGrantReportAccess()

  /**
   * POSTs a single `view_report` grant (BHV-012). Resolves with the created
   * grant so the Feature Set can highlight the new tag (BHV-013). No success
   * toast (Angular parity). Rejects after showing the error toast.
   */
  const grant = async (
    user: User,
    secondaryCategoryId: number
  ): Promise<ReportAccessGrant> => {
    try {
      return await grantReportAccess({
        userId: user.id,
        secondaryCategoryId,
      })
    } catch (err) {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.errorToastDefaultMessage),
      })

      throw err
    }
  }

  return {
    commands: {
      grant,
    },
    states: {
      isGranting,
    },
  }
}
